import React from 'react';
import Link from 'next/link';
import Icon from '@components/common/assets';
import Colors from '@domain/constant/colors';
import classnames from 'classnames/bind';
import styles from './index.module.scss';
const cx = classnames.bind(styles);

const ZipList = () => {
  return (
    <div className={cx('commonBox')}>
      {/* 타이틀 */}
      <div className={cx('basicTitleInner')}>
        <span className={cx('basicTitle')}>프로필 작성방법 고민된다면?</span>
        <span className={cx('subTitle')}>실제 합격자 프로필을 참고해보세요!</span>
      </div>

      {/* 링크 이동 */}
      <Link className={cx('btnBasic')} href={'https://www.jobda.im/event/mailProfile'} target="_blank">
        <span className={cx('title')}>
          <strong>[합격자 프로필 모음.ZIP]</strong> 받으러 가기
        </span>
        <Icon name="arrowRightLight" width={24} height={24} fill={Colors.C_JOBDA_BLACK} />
      </Link>
    </div>
  );
};

export default ZipList;
